import React, { useMemo } from "react";
import ReactTable from "@dhn/components/molecules/data-table";
import { Button, Col, Row, TabPane } from "reactstrap";
import ReactFormat from "react-number-format";
import StatusBadge from "@dhn/components/molecules/status-badge";
import useActions from "./useActions";
import { getMonthlyClosingPeriod } from "../../reports/reportContext";

// Color e icono por estatus del cierre mensual (1 abierto, 3 procesado).
const STATUS_STYLES = {
  1: { color: "warning", icon: "fa-unlock" },
  2: { color: "info" },
  3: { color: "success", icon: "fa-lock" },
};

const MONTH_NAMES = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

export default function MonthlyClosuresTable({
  history,
  dataDoctor,
  tabId,
  statusId,
  filterItem,
  action,
}) {
  const [{ data, isLoading }] = useActions({ dataDoctor, statusId, filterItem });

  const col = useMemo(
    () => [
      {
        Header: "Mes",
        className: "text-center",
        Cell: ({ original }) =>
          `${MONTH_NAMES[original?.month - 1] || ""} ${original?.year || ""}`.trim(),
      },
      {
        Header: "Período",
        className: "text-center",
        Cell: ({ original }) => getMonthlyClosingPeriod(original).rangeLabel,
      },
      {
        Header: "Valor Facturado",
        className: "text-right",
        Cell: ({ original }) => (
          <ReactFormat
            style={{ textAlign: "right", display: "block" }}
            value={original.consultingFee || "00.00"}
            thousandSeparator={true}
            fixedDecimalScale={true}
            decimalScale={2}
            displayType="text"
            prefix={"$"}
          />
        ),
      },
      {
        Header: "Estado",
        className: "text-center",
        Cell: ({ original }) => (
          <StatusBadge {...STATUS_STYLES[original?.status?.id]}>
            {original?.status?.name || "-"}
          </StatusBadge>
        ),
      },
      {
        Header: "Opciones",
        Cell: ({ original }) => (
          <Button
            className={`${action.className} card-header-action`}
            onClick={() => history.push(`${action.path}/${original?.id}`)}
          >
            <i className={`fa ${action.icon}`}></i>
            {` ${action.label}`}
          </Button>
        ),
      },
    ],
    [action, history],
  );

  return (
    <TabPane tabId={tabId}>
      <Row form>
        <Col>
          <ReactTable
            defaultPageSize={10}
            data={data}
            loading={isLoading}
            loadingText="Cargando datos..."
            noDataText="No hay datos para mostrar"
            columns={col}
          />
        </Col>
      </Row>
    </TabPane>
  );
}
